import { moduleState, props } from 'cerebral'
import { set, when } from 'cerebral/factories'
import apiClient from '../../lib/util/api-client'
import * as sequences from './sequences'

export default ({ name, app }) => {
  app.on('initialized', () => {
    const setConnected = app.getSequence(`${name}.setConnected`)
    const { connected } = apiClient.io
    setConnected({ connected })
    apiClient.io.on('connect', () => setConnected({ connected: true }))
    apiClient.io.on('disconnect', () => setConnected({ connected: false }))
  })

  return {
    state: {
      connected: false,
      mobileNavOpen: false,
      updateAvailable: false,
      profileSelectionPageSize: 20,
      metricCardsExpanded: true,
      metricGridMobileOpen: false,
      listViews: {},
    },
    sequences: {
      setConnected: set(moduleState`connected`, props`connected`),
      setMobileNavOpen: set(moduleState`mobileNavOpen`, props`open`),
      setUpdateAvailable: set(moduleState`updateAvailable`, true),
      setProfileSelectionPageSize: set(moduleState`profileSelectionPageSize`, props`pageSize`),
      setMetricCardsExpanded: set(moduleState`metricCardsExpanded`, props`expanded`),
      toggleMetricCardsExpanded: [
        when(moduleState`metricCardsExpanded`),
        { true: set(moduleState`metricCardsExpanded`, false), false: set(moduleState`metricCardsExpanded`, true) },
      ],
      setMetricGridMobileOpen: set(moduleState`metricGridMobileOpen`, props`open`),
      ...sequences,
    },
  }
}
